import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { BsPeople, BsPerson, BsCheck2Circle, BsDisplay, BsQuestion, BsFolder, BsGear } from 'react-icons/bs';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { FaCogs, FaUserShield, FaBoxes, FaChalkboardTeacher, FaQuestionCircle, FaTags, FaCogs as FaProcess, FaTh, FaRegQuestionCircle, FaClipboardList } from 'react-icons/fa';

const Admin = ({ titre }) => {
  useAuth();
  const location = useLocation();
  const user_id = localStorage.getItem('IDDDD');
  const accesGroupe = localStorage.getItem('accesGroupe');
  const groupe = localStorage.getItem('groupe');

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Administration"; // Définit le titre de la page
    }
  }, [user_id]);


  const userHasAccess = (accessKey) => {
    // Vérifie si 'acces' est non nul et inclut 'accessKey'
    return accesGroupe && accesGroupe.includes(accessKey);
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className='d-flex align-items-center'><FaCogs size={25} className='mr-2' /> Administration</h2>
              {/* <small>Administration</small> */}

              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="hbreadcrumb breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/admin`}> Administration</Link>
                  </li>
                </ol>
              </small>

            </div>
          </div>
          <div className="container text-center mt-5">
            <div className="row mx-auto justify-content-center">
              {/* Card for Groupes */}
              {userHasAccess('Groupes') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <BsPeople className="mb-3 icon-small" />
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/Liste-groupe`}>Groupes</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
              {/* Card for Utilisateurs */}
              {userHasAccess('Utilisateurs') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <BsPerson className="mb-3 icon-small" />
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/Liste-utilisateur`}>Utilisateurs</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
              {/* Card for Produits */}
              {userHasAccess('Produits') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <FaBoxes className="mb-3 icon-small" />
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/Liste-produit`}>Produits</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
              {userHasAccess('Categories') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <FaBoxes className="mb-3 icon-small" />
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/Liste-categorie`}>Catégories</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row mx-auto justify-content-center">
              {/* Card for liste de diffusion */}
              {userHasAccess('Transactions') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <FaClipboardList className="mb-3 icon-small" />
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/transaction`}>Transactions</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
               {/* Card for Notification */}
               {userHasAccess('Notification') && (
                <div className="col-md-2 mb-4">
                  <div className="card rounded shadow-sm">
                    <div className="card-body">
                      <i className="fa fa-bell-o icon-small mb-3"></i>
                      <h5 className="card-title">
                        <Link className='text-dark' to={`/Liste-notification`}>Notifications</Link>
                      </h5>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row mx-auto justify-content-center">
             </div> 
            <div className="row mx-auto justify-content-center">
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
